// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"333":"2b42e84f","340":"1a46207f","454":"9f6a66f8","895":"0cffc43b"}[chunkId] + ".css";
};